import { Component, OnInit } from '@angular/core';
import { format, isSameDay } from 'date-fns';
import { ActivityInternalViewModalComponent } from 'gung-standard';

@Component({
  selector: 'cult-cult-activity-internal-view-modal',
  templateUrl: './cult-activity-internal-view-modal.component.html',
  styleUrls: ['./cult-activity-internal-view-modal.component.scss']
})
export class CultActivityInternalViewModalComponent extends ActivityInternalViewModalComponent implements OnInit {
  activityDate: string = '';

  ngOnInit(): void {
    super.ngOnInit();
    this.activityDate = this.resolveActivityDate(this.data?.activityDate, this.data?.activityEndDate);
  }

  resolveActivityDate(startDateString: string, endDateString: string): string {
    if ((startDateString && !isNaN(Date.parse(startDateString))) && (endDateString && !isNaN(Date.parse(endDateString)))) {
      if (isSameDay(new Date(startDateString), new Date(endDateString))) {
        return format(new Date(startDateString), this.dateUtilService.dateFormat + ' HH:mm') + ' - ' + format(new Date(endDateString), 'HH:mm');
      }
      return format(new Date(startDateString), this.dateUtilService.dateFormat + ' HH:mm') + ' - ' + format(new Date(endDateString), this.dateUtilService.dateFormat + ' HH:mm');
    }

    if (!endDateString || isNaN(Date.parse(endDateString))) {
      return format(new Date(startDateString), this.dateUtilService.dateFormat + ' HH:mm');
    }
    
    return 'N/A';
  }
}